import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, ShieldCheck, FileSpreadsheet, ClipboardCheck, Building2, Scale } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
export function Services() {
  const services = [{
    icon: Globe2,
    title: 'Global Sourcing',
    description: 'Identifying and engaging capable manufacturers and distributors across global markets to meet specific project requirements.'
  }, {
    icon: ShieldCheck,
    title: 'Supplier Verification',
    description: 'Rigorous due diligence, financial vetting, and compliance checking to ensure suppliers meet institutional standards.'
  }, {
    icon: FileSpreadsheet,
    title: 'Tender Coordination',
    description: 'End-to-end support in preparing, formatting, and submitting complex bid documents for multilateral projects.'
  }, {
    icon: ClipboardCheck,
    title: 'Pre-Qualification',
    description: 'Managing the pre-qualification process to position suppliers favorably for upcoming procurement opportunities.'
  }, {
    icon: Building2,
    title: 'Institutional Liaison',
    description: 'Acting as a bridge between suppliers and procurement bodies, ensuring clear communication and requirement alignment.'
  }, {
    icon: Scale,
    title: 'Compliance Advisory',
    description: 'Guidance on meeting the stringent environmental, social, and governance (ESG) criteria of modern tenders.'
  }];
  return <section id="services" className="py-24" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-158">
          <SectionHeader eyebrow="What We Do" title="Strategic Procurement Services" description="Comprehensive support across the entire procurement lifecycle, from initial supplier identification to final bid submission." centered data-id="element-159" />
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16" data-id="element-160">
          {services.map((service, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-card p-8 rounded-sm border border-navy-border hover:border-gold transition-colors group" data-id="element-161">
              <div className="w-14 h-14 bg-navy flex items-center justify-center rounded mb-6 group-hover:bg-gold/10 transition-colors" data-id="element-162">
                <service.icon size={28} className="text-gold" data-id="element-163" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-164">
                {service.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-165">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}